export enum NetwinLoaders {
    isNetwinUsersLoading,
    isNetwinRoyaltyLoading
}